import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  requestUpdateDeliveryZone,
  UpdateDeliveryZoneBody
} from "./updateDeliveryZone.request";

const useUpdateDeliveryZone = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    UpdateDeliveryZoneBody
  >
) => {
  return useMutation({
    mutationFn: requestUpdateDeliveryZone,
    onError: toastServerError,
    ...options
  });
};

export default useUpdateDeliveryZone;
